import React from 'react'
import Responsive from 'react-responsive'
import { sizes } from 'themes'

const Default = props => <Responsive {...props} minWidth={sizes.tablet + 1} />

export { Default }
